import React from 'react';
import { choose } from '../../utils/platform';
import { useInviteForms } from './useInviteForms';
import InviteFormsDesktop from './InviteForms.desktop';
import InviteFormsMobile from './InviteForms.mobile';

const InviteFormsView = choose(InviteFormsDesktop, InviteFormsMobile);

export default function InviteForms() {
  const vm = useInviteForms();
  return <InviteFormsView vm={vm} />;
}
